import Service from '@ember/service';
import { tracked } from '@glimmer/tracking';

export default class HeadService extends Service {
  @tracked title = '1vX.gg - Gaming Community & Esports Platform';
  @tracked description = 'Join the ultimate gaming community for esports tournaments, player stats, and competitive gaming.';
  @tracked ogTitle = '1vX.gg - Gaming Community & Esports Platform';
  @tracked ogDescription = 'Join the ultimate gaming community for esports tournaments, player stats, and competitive gaming.';
  @tracked ogImage = '/assets/images/og-default.png';
  @tracked ogType = 'website';
  @tracked twitterCard = 'summary_large_image';
  @tracked twitterSite = '@1vxgg';
  @tracked canonical = '';
  @tracked robots = '';

  updateMeta({ title, description, ogTitle, ogDescription, ogImage, ogType, twitterCard, canonical, robots }: {
    title?: string;
    description?: string;
    ogTitle?: string;
    ogDescription?: string;
    ogImage?: string;
    ogType?: string;
    twitterCard?: string;
    canonical?: string;
    robots?: string;
  } = {}) {
    if (title !== undefined) this.title = title;
    if (description !== undefined) this.description = description;
    if (ogTitle !== undefined) this.ogTitle = ogTitle;
    if (ogDescription !== undefined) this.ogDescription = ogDescription;
    if (ogImage !== undefined) this.ogImage = ogImage;
    if (ogType !== undefined) this.ogType = ogType;
    if (twitterCard !== undefined) this.twitterCard = twitterCard;
    if (canonical !== undefined) this.canonical = canonical;
    if (robots !== undefined) this.robots = robots;
  }

  reset() {
    this.title = '1vX.gg - Gaming Community & Esports Platform';
    this.description = 'Join the ultimate gaming community for esports tournaments, player stats, and competitive gaming.';
    this.ogTitle = '1vX.gg - Gaming Community & Esports Platform';
    this.ogDescription = 'Join the ultimate gaming community for esports tournaments, player stats, and competitive gaming.';
    this.ogImage = '/assets/images/og-default.png';
    this.ogType = 'website';
    this.twitterCard = 'summary_large_image';
    this.canonical = '';
    this.robots = '';
  }
}